import React from 'react';
import { cn } from '~/lib/utils';

function Table({ className, ...props }) {
	return (
		<div className="relative w-full overflow-x-auto">
			<table className={cn('w-full caption-bottom text-sm', className)} {...props} />
		</div>
	);
}

function TableHeader({ className, ...props }) {
	return <thead className={cn('[&_tr]:border-b [&_tr]:border-border', className)} {...props} />;
}

function TableBody({ className, ...props }) {
	return <tbody className={cn('[&_tr:last-child]:border-0', className)} {...props} />;
}

function TableRow({ className, ...props }) {
	return (
		<tr
			className={cn(
				'border-b border-border transition-colors hover:bg-muted/40 data-[state=selected]:bg-muted',
				className
			)}
			{...props}
		/>
	);
}

function TableHead({ className, ...props }) {
	return (
		<th
			className={cn(
				'h-10 px-3 text-left align-middle text-sm font-medium text-muted-foreground whitespace-nowrap [&:has([role=checkbox])]:pr-0',
				className
			)}
			{...props}
		/>
	);
}

function TableCell({ className, ...props }) {
	return (
		<td
			className={cn(
				'px-3 py-2 align-middle text-sm [&:has([role=checkbox])]:pr-0',
				className
			)}
			{...props}
		/>
	);
}

export {
	Table, TableHeader, TableBody, TableRow, TableHead, TableCell
};
